<!--
 * @Author: your name
 * @Date: 2021-07-01 17:04:05
 * @LastEditTime: 2021-07-13 17:30:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\views\contents\foodColumn\component\picture.vue
-->
<script>
import { previewImgage } from "../preview.js";
export default {
  props: {
    foodImg: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    previewFoodimg() {
      let arr = [];
      this.foodImg.forEach((res) => arr.push(res.imgUrl));
      return arr;
    },
  },
  methods: {
    /**
     * @description: 预览图片
     * @param {*} e
     * @param {*} index 下标
     * @return {*}
     */    
    clickPreview(e,index) {
      e.stopPropagation()
      previewImgage(
         this.previewFoodimg,index
        
      );
    },
  },
  render() {
    return (
      <div class="img-box">
      {console.log(this.foodImg)}
        {this.foodImg.map((res, index) => {
          return (
            <img onClick={(e) =>this.clickPreview(e,index)} src={res.imgUrl} />
          );
        })}
      </div>
    );
  },
};
</script>
<style lang="less" scoped>
.img-box {
  padding: 15px 0 5px 0;
  img {
    width: 95px;
    height: 91px;
    margin-right: 5px;
    border-radius: 4px;
   
  }
}
</style>
